import { render, staticRenderFns } from "./Softline82Tabs.vue?vue&type=template&id=6faf30cf&"
import script from "./Softline82Tabs.vue?vue&type=script&lang=js&"
export * from "./Softline82Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports